import { Link } from '@auspost/postmaster-react';

import Infotip from 'App/common/Tooltip/Infotip/infotip';
import { ReactComponent as LicenseIcon } from 'assets/license.svg';
import { ReactComponent as SignatureIcon } from 'assets/signature.svg';
import { extLnkMyPostSafeDropTerms } from 'config/track-config';

import styles from '../DeliveryInstructions.module.scss';

const senderLine = (
  atlEligible?: boolean,
  intlOutbound?: boolean | null,
  safeDropIneligibilityCode?: string | null
) => {
  let displaySenderLine = atlEligible ? (
    <>
      <SignatureIcon className={styles.icon} />
      Sender requested a signature
      <Infotip floatClassName={styles.senderLineInfotip}>
        {intlOutbound ? IntSenderRequestedSignTooltip : senderRequestedSignTooltip}
      </Infotip>
    </>
  ) : (
    ''
  );
  if (!displaySenderLine) {
    switch (safeDropIneligibilityCode) {
      case '1':
        displaySenderLine = 'No signature required';
        break;
      case '2':
      case '5':
      case '6':
      case 'X':
      case 'Y':
        displaySenderLine = (
          <>
            <SignatureIcon className={styles.icon} />
            Sender requires a signature
            <Infotip>{intlOutbound ? IntSenderRequiresSignTooltip : senderRequiresSignTooltip}</Infotip>
          </>
        );
        break;
      case '7':
        displaySenderLine = (
          <>
            <LicenseIcon className={styles.icon} />
            <SignatureIcon className={styles.icon} />
            Sender requires a signature and ID
            <Infotip>{intlOutbound ? IntSenderRequiresSignAndIdTooltip : senderRequiresSignAndIdTooltip}</Infotip>
          </>
        );
        break;
      default:
        return null;
    }
  }

  return displaySenderLine;
};

const senderRequestedSignTooltip = (
  <>
    <p>
      The sender asked for a signature on delivery, but they&apos;re happy for this parcel to be left in a safe place if
      the recipient authorises it.
    </p>
    <p>
      <span>For more information, read the </span>
      <Link href={extLnkMyPostSafeDropTerms} target='_blank'>
        MyPost Safe Drop Terms and Conditions.
      </Link>
    </p>
  </>
);

const senderRequiresSignTooltip = (
  <p>
    The recipient won&apos;t be able to give us authority to leave this parcel, because the sender requires a signature
    on delivery.
  </p>
);

const senderRequiresSignAndIdTooltip = (
  <p>
    The recipient won&apos;t be able to give us authority to leave this parcel, because the sender requires a signature
    and ID check on delivery.
  </p>
);

const IntSenderRequestedSignTooltip = (
  <>
    <p>
      The sender asked for a signature on delivery, but they&apos;re happy for this parcel to be left in a safe place if
      the recipient authorises it.
    </p>
    <p>This option may be offered by the postal carrier in the destination country. </p>
  </>
);

const IntSenderRequiresSignTooltip = (
  <p>
    The recipient won&apos;t be able to give the local carrier authority to leave this parcel, because the sender
    requires a signature on delivery.
  </p>
);

const IntSenderRequiresSignAndIdTooltip = (
  <p>
    The recipient won&apos;t be able to give the local carrier authority to leave this parcel, because the sender
    requires a signature and ID check on delivery.
  </p>
);

export default senderLine;
